import { useMutation, useQueryClient } from '@tanstack/react-query';
import { movePotToActivePeriod } from '../api/potsApi';

interface MovePotParams {
  potId: string;
}

/**
 * Mutation hook for moving a pot with MissedSubmitDeadline status to the current active period.
 * Moves the pot and its allocations to the current week, setting status to Verified.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export function useMovePotToActivePeriod() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ potId }: MovePotParams) => {
      return await movePotToActivePeriod({ potId });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pots'] });
      queryClient.invalidateQueries({ queryKey: ['potDetails'] });
      queryClient.invalidateQueries({ queryKey: ['potPeriods'] });
    },
  });
}
